<template>
  <v-card class="oderon-card elevation-0">
    <v-toolbar>
      <v-toolbar-title>Valores</v-toolbar-title>

      <!-- <v-btn icon class="ml-4" @click="reload">
        <v-icon>mdi-refresh</v-icon>
      </v-btn> -->

      <v-spacer />

      <v-btn color="primary" class="mr-2" @click="editItem(null)">
        Novo Item...
      </v-btn>

      <OMenuButton :menuOpts="menuOpts" />
    </v-toolbar>

    <OLoadingLine absolute :value="isLoading" />

    <EditValueDialog ref="editDialog" />
    <CopyValuesDialog ref="copyDialog" />

    <ODataGrid
      v-if="gridData != null"
      class="maxh-full-4"
      :data="gridData"
      :selectable="true"
      :selected="selectedNames"
      :order.sync="order"
      @rowClicked="editItem"
    />
  </v-card>
</template>

<script>
import { Technician } from '@/models'
import ODataGrid from 'oderon-vue/cpts/ODataGrid'
import utils from 'oderon-commons/src/utils'
import { brDec } from 'oderon-commons/src/formatters'
import grid from 'oderon-commons/src/grid'
import { preProcessSpec } from 'oderon-commons/src/tables'
import EditValueDialog from './EditValueDialog.vue'
import CopyValuesDialog from './CopyValuesDialog.vue'

const fullSpec = preProcessSpec({
  defaultSortable: true,
  idProp: 'name',
  columns: [
    { t: 'Item', code: 'name', d: 'name' },
    { t: 'Valor|', code: 'value', d: 'value', f: brDec }
  ]
})

export default {
  components: { ODataGrid, EditValueDialog, CopyValuesDialog },
  props: {
    row: { required: true }
  },
  data() {
    return {
      isLoading: false,
      selectedNames: [],
      order: 'name asc'
    }
  },
  computed: {
    gridData() {
      let rows = this.row.values
      let criteria = utils.order(this.order)
      let ordered = utils.orderBy(rows, criteria)
      return grid.generateWebGrid({ rows: ordered, spec: fullSpec })
    },

    menuOpts() {
      return [
        { text: 'Copiar...', onClick: () => this.copyItems() },
        {
          text: 'Ajustar...',
          onClick: () => {},
          disabled: true
          // disabled: this.selectedNames.length < 1
        },
        { isDivider: true },
        {
          text: 'Remover',
          onClick: () => this.removeSelected(),
          disabled: this.selectedNames.length < 1
        }
      ]
    }
  },

  methods: {
    async editItem(item) {
      if ( item != null ) {
        item = this.row.values.find(x => x.name == item.id)
      }

      let changed = await this.$refs.editDialog.open(item)
      if (changed != null) {
        if (item == null) this.row.values.push(changed)
        else Object.assign(item, changed)


        await Technician.patch(this.row.id, { values: this.row.values })
        this.$emit('reload')
      }
    },

    async copyItems() {
      let newItems = await this.$refs.copyDialog.open(this.row)
      if (newItems != null) {
        for (let it of newItems) {
          let old = this.row.values.find(x => x.name == it.name)
          if ( old == null ) this.row.values.push(it)
          else old.value = it.value
        }
        await Technician.patch(this.row.id, { values: this.row.values })
        this.$emit('reload')
      }
    },

    async removeSelected() {
      let ok = await this.$confirmDelete(`
        Deseja remover os ${this.selectedNames.length}
        itens selecionados? Esta alteração não muda
        os registros de histórico que já foram lançados.
      `)

      if (ok) {
        this.row.values = this.row.values.filter(x => {
          if (this.selectedNames.includes(x.name)) return false
          return true
        })

        await Technician.patch(this.row.id, { values: this.row.values })
        this.$emit('reload')
      }
    }
  }
}
</script>

<style></style>
